import React, { useEffect } from "react";

import makeStyles from "@material-ui/core/styles/makeStyles";
import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import MarathonRequests from "services/marathon";

import { useDispatch, useSelector } from "react-redux";
import { Typography } from "@material-ui/core";
import CheckIcon from "@material-ui/icons/Check";
import ClearIcon from "@material-ui/icons/Clear";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 20,
    marginBlock: "20px",
  },
  imageContainer: {
    width: "100px",
    height: "auto",
    borderRadius: "1rem",
  },
}));

const MarathonAnswer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { id, quiz } = useParams();
  const { marathonAnswer } = useSelector(({ tests }) => tests);

  useEffect(() => {
    dispatch(MarathonRequests.getMarathonAnswer(quiz, id));
  }, []);

  return marathonAnswer.length !== 0 ? (
    marathonAnswer.map((item) => {
      return (
        <CmtCard className={classes.cardRoot}>
          <CmtCardContent className={classes.cardContentRoot}>
            <Typography>{item.question}</Typography>
            <hr style={{ marginBlock: "10px" }} />
            <Typography color="primary">پاسخ کاربر :</Typography>
            <Typography style={{ marginBlock: "10px" }}>
              {item.userAnswerString}
            </Typography>
            <Typography color="primary">پاسخ صحیح :</Typography>
            <Typography style={{ marginBlock: "10px" }}>
              {item.userWasRight ? (
                <CheckIcon color="primary" />
              ) : (
                <ClearIcon color="error" />
              )}
            </Typography>
            <Typography color="primary">دسته بندی :</Typography>
            <Typography style={{ marginBlock: "10px" }}>
              {item.questionCategory}
            </Typography>
             <Typography color="primary">امتیاز دریافتی :</Typography>
            <Typography style={{ marginBlock: "10px" }}>
              {item.score}
            </Typography>
          </CmtCardContent>
        </CmtCard>
      );
    })
  ) : (
    <Typography>موردی برای نمایش وجود ندارد.</Typography>
  );
};

export default MarathonAnswer;
